import { Icon } from 'Components/shared/Icon';
import React from 'react';
import { TransferHeaderProps } from './index.types';

/**
 * Component that allows the user to navigate back to the active call
 */
export const TransferHeader = ({
  onBack,
  testID,
  className,
}: TransferHeaderProps): React.ReactElement => {
  return (
    <nav
      className={`mt-[8px] mx-[16px] gap-[8px] flex flex-row items-center ${className ?? ''}`}
      data-testid={`${testID}-header`}
      aria-label="Transfer navigation"
    >
      <button
        type="button"
        onClick={onBack}
        className="flex items-center gap-[8px] cursor-pointer bg-transparent border-none p-0"
        aria-label="Return to call"
        data-testid={`${testID}-back-button`}
      >
        <Icon icon="back" size="medium" />
        <h2 className="leading-[19px] text-[14px] font-normal text-foreground">
          Return to call
        </h2>
      </button>
    </nav>
  );
};

TransferHeader.displayName = 'TransferHeader';
